<template>
  <aside
    :class="[
      'main-sidebar',
      'col-12',
      'col-md-3',
      'col-lg-2',
      'px-0',
      $store.state.ui.sidebarVisible ? 'open' : '',
    ]"
  >
    <div class="main-navbar">
      <nav
        class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0"
      >
        <a class="navbar-brand w-100 mr-0" href="#" style="line-height: 25px">
          <div class="d-table m-auto">
            <img
              class="d-inline-block align-top mr-1"
              style="max-width: 25px; max-height: 25px; object-fit: contain"
              :src="orgLogoSrc"
              alt=""
            />
            <span v-if="!hideLogoText" class="d-none d-md-inline ml-1">{{
              $store.state.settings.tenantSetting.orgName
            }}</span>
          </div>
        </a>
        <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>

    <form action="#" class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none">
      <div class="input-group input-group-seamless ml-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="material-icons">&#xE8B6;</i>
          </div>
        </div>
        <input
          class="navbar-search form-control"
          type="text"
          :placeholder="$t('generalMessages.searchForSomething')"
          aria-label="Search"
        />
      </div>
    </form>

    <div class="nav-wrapper">
      <d-nav class="flex-column">
        <li v-for="(item, navItemIdx) in items" :key="navItemIdx" class="nav-item dropdown">
          <div>
            <d-link
              :class="[
                'nav-link',
                item.items && item.items.length ? 'dropdown-toggle' : '',
                isSidebarSectionActive(item) ? 'router-link-active' : '',
              ]"
              :to="item.to"
              v-d-toggle="`snc-${navItemIdx}`"
            >
              <div @click="collabseFunction(item.title)">
                <div v-if="item.icon === 'calendar'" class="item-icon-wrapper">
                  <CalendarIcon />
                </div>
                <div class="item-icon-wrapper" v-else-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">
                  {{ item.title }}
                </span>

                <div
                v-if="count > 0 && item.title === $t('mainSideBar.tasks')"
                class="hint"
                :class="'active-entry-state'"
                >
                <label class="fontcolor"
                  >{{ count }}</label
                >
              </div>
                <div
                v-if="requestsCount > 0 && item.title === $t('mainSideBar.requests')"
                class="hint"
                :class="'active-entry-state'"
                >
                <label class="fontcolor"
                  >{{ requestsCount }}</label
                >
              </div>
                <div
                v-if="whatsNewUnread && item.title === $t('mainSideBar.whatsNew')"
                class="hint whats-new-nav-badge"
                >
                <label class="fontcolor"
                  >{{ $t('whatsNew.new') }}</label
                >
              </div>
              </div>
              <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
            </d-link>
          </div>

          <div
            v-show="showSchedule"
            v-if="item.title === $t('mainSideBar.schedule') && item.items && item.items.length"
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </d-dropdown-item>
          </div>
          <div
            v-show="showClassesManagement"
            v-if="
              item.title === $t('mainSideBar.classesManagement') && item.items && item.items.length
            "
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </d-dropdown-item>
          </div>
          <div
            v-show="showSystemSettings"
            v-if="
              item.title === $t('mainSideBar.systemSettings') && item.items && item.items.length
            "
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </d-dropdown-item>
          </div>
          <div
            v-show="showAccounting"
            v-if="item.title === $t('mainSideBar.finance') && item.items && item.items.length"
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </d-dropdown-item>
          </div>
          <div
            v-show="showReports"
            v-if="item.title === $t('mainSideBar.reports') && item.items && item.items.length"
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
            >
              {{ subItem.title }}
            </d-dropdown-item>
          </div>
        </li>
      </d-nav>
    </div>
  </aside>

</template>

<script>
import membershipsService from '@/services/memberships.service';
import tasksService from '@/services/tasks.service';
import membershipRequestsService from '@/services/membershipRequests.service';
import { routeMetaValue } from '@/utils/routePageState';
import { startVisibleInterval } from '@/utils/visibleInterval';
import { hasUnreadRelease } from '@/whats-new/releases';

export default {
  name: 'main-sidebar',
  components: {
  },
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    // items: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      items: [],
      count: this.$session.get('taskCount') || 0,
      requestsCount: this.$session.get('requestsCount') || 0,
      whatsNewUnread: false,
      stopCountPolling: null,
      showSchedule: false,
      showClassesManagement: false,
      showAccounting: false,
      showReports: false,
      showSystemSettings: false,
    };
  },
  created() {
    this.showSchedule = this.$session.get('showSchedule');
    this.showClassesManagement = this.$session.get('showClassesManagement');
    this.showAccounting = this.$session.get('showAccounting');
    this.showReports = this.$session.get('showReports');
    this.showSystemSettings = this.$session.get('showSystemSettings');

    if (this.$session.get('taskCount') === undefined && this.permissionTasksManagementPackageComputed) {
      this.getPendingTasksCount();
    }
    if (this.$store.state.settings.activeMembersCount === undefined) {
      this.getPackageLimit();
    }

    this.count = this.$session.get('taskCount') || 0;

    if (this.hasRequestsViewComputed) {
      this.getPendingRequestsCount();
    }
    this.$eventHub.$on('refresh-requests-count', this.getPendingRequestsCount);

    this.refreshWhatsNewMarker();
    this.$eventHub.$on('whats-new-seen', this.refreshWhatsNewMarker);

    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    this.prepareTheMenu();
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
    this.$eventHub.$off('refresh-requests-count', this.getPendingRequestsCount);
    this.$eventHub.$off('whats-new-seen', this.refreshWhatsNewMarker);
    this.stopInterval();
  },
  mounted() {
    this.$eventHub.$off('toggle-sidebar');
    this.stopInterval();
    this.$store.state.ui.sidebarVisible = false;
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    this.startInterval();
  },
  unmounted() {
  },
  destroyed() {
  },
  methods: {
    // The marker is per user and lives in localStorage, so it survives a reload but not a different
    // person signing in on the same browser.
    refreshWhatsNewMarker() {
      const userData = this.$store.state.auth.userData || {};
      this.whatsNewUnread = hasUnreadRelease(userData.userId);
    },
    isSidebarSectionActive(item) {
      if (!item || !item.to) return false;
      const section = routeMetaValue(this.$route, 'sidebarSection');
      return Boolean(section && section === item.to.name);
    },
    async getPackageLimit() {
      this.$store.commit('changeShowLoader', true);
      await membershipsService.getPackageMemberLimit()
        .then((data) => {
          if (data) {
            this.$store.commit('changeActiveMembersCount', data.activeMembersCount);
          }
        })
        .catch((err) => {
          this.showError(err, this.$t('errors.entities.menu'), 'load');
        });
      this.$store.commit('changeShowLoader', false);
    },
    collabseFunction(title) {
      // Accordion: open the clicked group (toggle if already open), collapse the rest.
      const groupFlagByTitle = {
        [this.$t('mainSideBar.schedule')]: 'showSchedule',
        [this.$t('mainSideBar.classesManagement')]: 'showClassesManagement',
        [this.$t('mainSideBar.finance')]: 'showAccounting',
        [this.$t('mainSideBar.reports')]: 'showReports',
        [this.$t('mainSideBar.systemSettings')]: 'showSystemSettings',
      };
      const targetFlag = groupFlagByTitle[title];
      ['showSchedule', 'showClassesManagement', 'showAccounting', 'showReports', 'showSystemSettings']
        .forEach((flag) => {
          const value = flag === targetFlag ? !this[flag] : false;
          this[flag] = value;
          this.$session.set(flag, value);
        });
    },
    // Paused while the tab is hidden: an idle background tab otherwise polls both counts all session.
    startInterval() {
      if (this.permissionTasksManagementPackageComputed || this.hasRequestsViewComputed) {
        this.stopCountPolling = startVisibleInterval(() => {
          if (this.permissionTasksManagementPackageComputed && this.$session.get('taskCount') !== undefined) {
            this.getPendingTasksCount();
          }
          if (this.hasRequestsViewComputed) {
            this.getPendingRequestsCount();
          }
        }, 10 * 60 * 1000);
      }
    },
    stopInterval() {
      if (this.stopCountPolling) {
        this.stopCountPolling();
        this.stopCountPolling = null;
      }
    },
    handleToggleSidebar() {
      this.$store.state.ui.sidebarVisible = !this.$store.state.ui.sidebarVisible;
    },
    async getPendingTasksCount() {
      await tasksService.getPendingCount()
        .then((data) => {
          this.count = data;
          if (this.count === 0) {
            this.$session.set('taskCount', undefined);
          } else {
            this.$session.set('taskCount', this.count);
          }
        })
        .catch(() => {});
    },
    getPendingRequestsCountRequests() {
      const requests = [
        membershipRequestsService.listMembershipRequests({ status: 'pending' }),
      ];

      if (this.hasClassRequestsViewComputed) {
        requests.push(membershipRequestsService.listClassRequests({ status: 'pending' }));
      }

      return requests;
    },
    async getPendingRequestsCount() {
      if (!this.hasRequestsViewComputed) {
        this.requestsCount = 0;
        this.$session.set('requestsCount', 0);
        return;
      }

      try {
        const [plans, classes] = await Promise.all(this.getPendingRequestsCountRequests());
        let total = 0;
        if (plans && typeof plans.totalItemCount === 'number') {
          total += plans.totalItemCount;
        } else if (plans && Array.isArray(plans.data)) {
          total += plans.data.length;
        }
        if (Array.isArray(classes)) {
          total += classes.filter((c) => !c.status || c.status === 'pending').length;
        }
        this.requestsCount = total;
        this.$session.set('requestsCount', total);
      } catch (e) {
        // keep last known count
      }
    },
    prepareTheMenu() {
      const loggedInUserAuthActions = this.$store.state.auth.userAuthActions;
      const { isTrainer } = this.$store.state.auth.userData;

      if (isTrainer) {
        const scheduleTree = {
          title: this.$t('mainSideBar.schedule'),
          icon: 'calendar',
          items: [
            {
              title: this.$t('mainSideBar.calendar'),
              to: {
                name: 'calender',
              },
            },
          ],
        };
        this.items.push(scheduleTree);

        if (this.permissionTasksManagementPackageComputed) {
          this.items.push({
            title: this.$t('mainSideBar.tasks'),
            htmlBefore: '<i class="material-icons">list_alt</i>',
            to: {
              name: 'task-grid',
            },
          });
        }
      } else {
        // Dashboard
        this.items.push({
          title: this.$t('mainSideBar.dashboard'),
          to: {
            name: 'dashboard',
          },
          htmlBefore: '<i class="material-icons">dashboard</i>',
          htmlAfter: '',
        });

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'reception-desk-enabled') && this.permissionReceptionDeskPackageComputed) {
          this.items.push({
            title: this.$t('mainSideBar.receptionDesk'),
            htmlBefore: '<i class="material-icons">vertical_split</i>',
            to: {
              name: 'reception-desk',
            },
          });
        }

        // this.items.push({
        //   title: this.$t("mainSideBar.leads"),
        //   htmlBefore: '<i class="material-icons">flaky</i>',
        //   to: {
        //     name: "leads",
        //   },
        // });

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'memberships-enabled') && this.permissionMembershipsManagementComputed) {
          this.items.push({
            title: this.$t('mainSideBar.memberships'),
            htmlBefore: '<i class="material-icons">subscriptions</i>',
            to: {
              name: 'memberships',
            },
          });
        }

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'members-enabled') && this.permissionMembersManagementComputed) {
          this.items.push({
            title: this.$t('mainSideBar.membersManagement'),
            htmlBefore: '<i class="material-icons">loyalty</i>',
            to: {
              name: 'members-management',
            },
          });
        }

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'requests-view')) {
          this.items.push({
            title: this.$t('mainSideBar.requests'),
            htmlBefore: '<i class="material-icons">how_to_reg</i>',
            to: {
              name: 'requests',
            },
          });
        }

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'trainers-management-enabled') && this.permissionProfessionalsComputed) {
          this.items.push({
            title: this.$t('professionals.title'),
            htmlBefore: '<i class="material-icons">health_and_safety</i>',
            to: {
              name: 'professionals-management',
            },
          });
        }

        if (loggedInUserAuthActions.find((i) => i.actionCode === 'point-of-sale-enable') && this.permissionPointOfSalePackageComputed) {
          this.items.push({
            title: this.$t('mainSideBar.pointOfSale'),
            htmlBefore: '<i class="material-icons">point_of_sale</i>',
            to: {
              name: 'point-of-sale',
            },
          });
        }
        // we need to always show it
        const scheduleTree = {
          title: this.$t('mainSideBar.schedule'),
          icon: 'calendar',
          // to: {
          //   name: 'schedule',
          // },
          items: [
            {
              title: this.$t('mainSideBar.calendar'),
              to: {
                name: 'calender',
              },
            },
          ],
        };
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'events-enabled')) {
          scheduleTree.items.push({
            title: this.$t('mainSideBar.events'),
            to: {
              name: 'events',
            },
          });
        }
        if (this.permissionStaffSchedulingPackageComputed) {
          scheduleTree.items.push({
            title: this.$t('roster.scheduleTitle'),
            to: {
              name: 'staff-rota',
            },
          });
        }
        this.items.push(scheduleTree);

        // Consolidated Classes Management group (Activities + Training Groups + Booking Policy).
        // Sessions/Enrollments/Attendance stay contextual deep-links from a Training Group.
        if (this.permissionClassManagementPackageComputed) {
          const classesManagementTree = {
            title: this.$t('mainSideBar.classesManagement'),
            htmlBefore: '<i class="material-icons">event_available</i>',
            items: [],
          };
          if (loggedInUserAuthActions.find((i) => i.actionCode === 'classes-enabled')) {
            classesManagementTree.items.push({
              title: this.$t('mainSideBar.trainingGroups'),
              to: {
                name: 'classes',
              },
            });
          }
          if (loggedInUserAuthActions.find((i) => i.actionCode === 'class-policy-manage')) {
            classesManagementTree.items.push({
              title: this.$t('mainSideBar.bookingPolicy'),
              to: {
                name: 'booking-policy',
              },
            });
          }
          if (classesManagementTree.items.length) {
            this.items.push(classesManagementTree);
          }
        }

        const financeTree = {
          title: this.$t('mainSideBar.finance'),
          htmlBefore: '<i class="material-icons">money</i>',
          // to: {
          //   name: 'finance',
          // },
          items: [],
        };
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'sales-enabled')) {
          financeTree.items.push({
            title: this.$t('mainSideBar.sales'),
            to: {
              name: 'sales',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'payments-enabled') && this.permissionPaymentManagementComputed) {
          financeTree.items.push({
            title: this.$t('mainSideBar.payments'),
            to: {
              name: 'payments',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'expenses-enabled') && this.permissionExpensesManagementPackageComputed) {
          financeTree.items.push({
            title: this.$t('mainSideBar.expenses'),
            to: {
              name: 'expenses',
            },
          });
        }
        if (this.permissionInventoryEnabledComputed && this.permissionInventoryPackageComputed) {
          financeTree.items.push({
            title: this.$t('mainSideBar.inventory'),
            to: {
              name: 'inventory',
            },
          });
        }

        if (
          loggedInUserAuthActions.find(
            (i) => i.actionCode === 'finance-cashbox-management-enable',
          )
          && this.permissionPaymentManagementComputed
        ) {
          financeTree.items.push({
            title: this.$t('mainSideBar.cashBoxesManagement'),
            to: {
              name: 'cashboxes-management',
            },
          });
        }
        // Only show the Finance section if at least one of its items is available for this tenant.
        if (financeTree.items.length > 0) {
          this.items.push(financeTree);
        }

        if (this.permissionTasksManagementPackageComputed) {
          this.items.push({
            title: this.$t('mainSideBar.tasks'),
            htmlBefore: '<i class="material-icons">list_alt</i>',
            to: {
              name: 'task-grid',
            },
          });
        }

        this.items.push({
          title: this.$t('mainSideBar.reports'),
          htmlBefore: '<i class="material-icons">library_books</i>',
          to: {
            name: 'reports-grid',
          },
        });

        // Between Reports and System Settings: it is reference material, not a daily task, but it
        // should sit above settings where people go looking when stuck.
        this.items.push({
          title: this.$t('mainSideBar.userGuide'),
          htmlBefore: '<i class="material-icons">menu_book</i>',
          to: {
            name: 'help',
          },
        });

        // Next to the guide rather than at the top: it is worth finding, but it is not somewhere
        // anyone needs to go daily.
        this.items.push({
          title: this.$t('mainSideBar.whatsNew'),
          htmlBefore: '<i class="material-icons">campaign</i>',
          to: {
            name: 'whats-new',
          },
        });

        const systemSettingsTree = {
          title: this.$t('mainSideBar.systemSettings'),
          htmlBefore: '<i class="material-icons">settings</i>',
          // to: {
          //   name: 'System Settings',
          // },
          items: [],
        };
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'membership-types-enabled') && this.permissionMembershipsManagementComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.membershipTypes'),
            htmlBefore: '<i class="material-icons">person</i>',
            to: {
              name: 'membership-types',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'security-users-enabled')) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.users'),
            to: {
              name: 'users',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'security-roles-enable')) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.securityRoles'),
            to: {
              name: 'security-roles',
            },
          });
        }
        if (this.permissionPointOfSalePackageComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.products'),
            to: {
              name: 'products',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'vendor-enabled')
            && this.permissionInventoryPackageComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.vendorManagement'),
            to: {
              name: 'vendor-grid',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'divisions-enabled')) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.divisions'),
            to: {
              name: 'divisions',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'levels-enabled')) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.levels'),
            to: {
              name: 'levels',
            },
          });
        }
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'gates-enabled') && this.permissionReceptionDeskPackageComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.gates'),
            to: {
              name: 'gates',
            },
          });
        }
        if (loggedInUserAuthActions.some((i) => i.actionCode === 'branches-enabled') && this.permissionMultipleBranchesManagementPackageComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.branches'),
            to: {
              name: 'branches',
            },
          });
          systemSettingsTree.items.push({
            title: this.$t('branches.regions'),
            to: {
              name: 'regions',
            },
          });
        }
        systemSettingsTree.items.push({
          title: this.$t('shifts.title'),
          to: {
            name: 'shifts',
          },
        });
        systemSettingsTree.items.push({
          title: this.$t('memberFields.title'),
          to: {
            name: 'member-fields',
          },
        });
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'expense-items-enabled') && this.permissionExpensesManagementPackageComputed) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.expenseItems'),
            to: {
              name: 'expense-items',
            },
          });
        }
        if (
          loggedInUserAuthActions.find((i) => i.actionCode === 'currencies-management-enable')
        ) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.currenciesManagement'),
            to: {
              name: 'currencies-management',
            },
          });
        }
        if (
          loggedInUserAuthActions.find((i) => i.actionCode === 'finance-cashbox-admin-enabled')
        ) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.cashBoxes'),
            to: {
              name: 'cash-boxes',
            },
          });
        }
        systemSettingsTree.items.push({
          title: this.$t('mainSideBar.customerCommunicationSettings'),
          to: {
            name: 'customer-communication-settings',
          },
        });
        if (loggedInUserAuthActions.find((i) => i.actionCode === 'admin-org-settings-enable')) {
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.organizationSettings'),
            to: {
              name: 'organization-settings',
            },
          });
          systemSettingsTree.items.push({
            title: this.$t('mainSideBar.memberAppSettings'),
            to: {
              name: 'member-app-settings',
            },
          });
        }
        this.items.push(systemSettingsTree);
      }
    },
  },
  computed: {
    orgLogoSrc() {
      const { orgLogoDocumentId, orgLogoURL } = this.$store.state.settings.tenantSetting;
      if (orgLogoDocumentId && orgLogoDocumentId > 0) {
        return this.fetchCachedImage(orgLogoDocumentId, () => orgLogoURL) || orgLogoURL;
      }
      return orgLogoURL;
    },
    permissionInventoryEnabledComputed() {
      return this.can('inventory-transactions-enabled');
    },
    permissionMultipleBranchesManagementPackageComputed() {
      return this.hasFeature('multiple-branches');
    },
    permissionExpensesManagementPackageComputed() {
      return this.hasFeature('expenses-management');
    },
    permissionTasksManagementPackageComputed() {
      return this.hasFeature('tasks-management');
    },
    permissionReceptionDeskPackageComputed() {
      return this.hasFeature('check-ins');
    },
    permissionClassManagementPackageComputed() {
      return this.hasFeature('classes-management');
    },
    permissionInventoryPackageComputed() {
      return this.hasFeature('inventory-management');
    },
    permissionPointOfSalePackageComputed() {
      return this.hasFeature('point-of-sale');
    },
    permissionStaffSchedulingPackageComputed() {
      return this.hasFeature('staff-scheduling');
    },
    permissionPaymentManagementComputed() {
      return this.hasFeature('payments-management');
    },
    permissionMembersManagementComputed() {
      return this.hasFeature('members-management');
    },
    permissionMembershipsManagementComputed() {
      return this.hasFeature('memberships-management');
    },
    permissionProfessionalsComputed() {
      return this.hasFeature('professionals-management');
    },
    hasRequestsViewComputed() {
      return this.can('requests-view');
    },
    hasClassRequestsViewComputed() {
      return this.hasRequestsViewComputed
        && this.permissionClassManagementPackageComputed
        && this.can('classes-enabled');
    },
  },
};
</script>

<style lang="scss">
.main-sidebar {
  .item-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.25rem;
  }

  .dropdown-menu {
    display: block;
  }
}
.main-sidebar .dropdown-menu .dropdown-item {
  padding: 0.75rem 1.75rem;
  cursor: pointer;
}

.item-inline {
  display: inline;
  margin-right: 5px;
  padding: 2px;
}

@media screen and (max-width: 767px) {
  .main-sidebar .nav-wrapper{
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 11.75rem - 1px);
  }
}

/* Style for the element */
.hint {
  position: relative; /* Required for positioning the tooltip */
  display: inline-flex;
  align-items: center;
  margin-left: auto;
}

.active-entry-state{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 1.4rem;
    height: 1.4rem;
    padding: 0 0.4rem;
    background-color: var(--fitnet-primary);
    color: #fff;
    border-radius: 0.5rem;
    font-size: 0.72rem;
    line-height: 1;
  }

  .whats-new-nav-badge {
    min-width: auto;
    height: 1.15rem;
    padding: 0 0.4rem;
    background: #1c7a4d;
    border: 1px solid #1c7a4d;
    border-radius: 999px;

    .fontcolor {
      color: #fff;
      font-size: 0.65rem;
      font-weight: 700;
      line-height: 1.2;
    }
  }

  .fontcolor{
    color: white;
    font-weight: bold;
    margin: 0;
    white-space: nowrap;
  }

  .menu-item {
  display: flex;        /* or block */
  width: 100%;          /* Take full width */
  white-space: nowrap;  /* Prevent text wrapping */
  overflow: visible;    /* Ensure it's not hidden */
}

.sidebar-menu {
  width: 100%;           /* or a fixed width like 200px */
}
</style>
